import { MdArrowBack } from 'react-icons/md';
import { BatchCollectConsignment } from 'types';
import { Heading, PrintTemplate, Text } from 'components';
import { formatTimestamp } from 'helpers';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface CollectReceiptModalProps {
  name: string;
  cpf: string;
  collector?: string;
  collectionDate?: Date;
  batchCollectConsignments: BatchCollectConsignment[];
  isSubmitting?: boolean;
  isReceiptReady?: boolean;
  signatureCanvas: JSX.Element;
  signatureButtons: JSX.Element;
  signatureImage?: string;
  close: () => void;
}

export function CollectReceiptModal({
  name,
  cpf,
  collector,
  collectionDate = new Date(),
  batchCollectConsignments,
  isSubmitting,
  isReceiptReady,
  signatureCanvas,
  signatureButtons,
  signatureImage,
  close,
}: CollectReceiptModalProps) {
  const { formattedDate, hour, minute } = formatTimestamp(collectionDate);

  return (
    <S.Wrapper>
      {isReceiptReady && !isSubmitting ? (
        <S.ReceiptTemplate>
          <S.Content>
            <S.CloseButton>
              <button type="button" onClick={close}>
                <MdArrowBack size={16} />
              </button>
            </S.CloseButton>
          </S.Content>
          <PrintTemplate.CollectReceipt
            batchCollectConsignments={batchCollectConsignments}
            cpf={cpf}
            name={name}
            collector={collector}
            collectionDate={collectionDate}
            signatureImage={signatureImage}
          />
        </S.ReceiptTemplate>
      ) : (
        <>
          <S.Content>
            <S.CloseButton>
              <button type="button" onClick={close}>
                <MdArrowBack size={16} />
              </button>
            </S.CloseButton>
            <Heading size={FontSize.font14} weight={FontWeight.bold}>
              Solicite que transportador confirme suas informações e assine
              abaixo.
            </Heading>

            <Text>
              Eu, <strong>{name}</strong>, CPF <strong>{cpf}</strong>, em nome
              de {collector}, confirmo a retirada dos pedidos a seguir em{' '}
              <strong>{formattedDate}</strong>, às{' '}
              <strong>
                {hour}:{minute}
              </strong>
              .
            </Text>
          </S.Content>
          <S.SignatureContent>
            {signatureCanvas}
            <S.Signature>
              <Text size={FontSize.font18}>assinatura do transportador</Text>
            </S.Signature>

            {signatureButtons}
          </S.SignatureContent>
        </>
      )}
    </S.Wrapper>
  );
}
